import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../../components/layout';
import HeroChatbot from '../../components/heroChatbot';
import IntakeSection from '../../components/intakeSection';
import HelpSection from '../../components/helpSection';
import IntakeSolutionsSection from '../../components/intakeSolutionSection';
import DemoFormSection from '../../components/demoFormSection';

export default function AiChatbot({ location }) {

  return (
    <Layout location={location} isDarkNav isChatbotNav noFooterMargin>
      <Helmet>
        <title>
          AI Intake Chatbot | Convert more leads!
        </title>
        <meta
          name='description'
          content="Our AI intake chatbot was designed to bring the power of AI to your website. You won't miss another web lead with this chatbot on your team. Sign up for a demo today!"

        />
      </Helmet>
      <HeroChatbot />
      <IntakeSection />
      <HelpSection />
      <IntakeSolutionsSection/>
      <DemoFormSection/>
    </Layout>
  );
}
